import { MESSAGE_IDS } from "constants/message-ids";
import { pluralize, numberToOrdinal } from "custom/string-helper";

const insertNumbersIntoMessage = (message, attempts, max) => {
    const regex = /~(.*?)~/g;

    const replacedMessage = message.replace(regex, (match, content) => {
        const parts = content.split(".");
        let text = "";
        let number = -1;

        if (parts[0] === "attempt") {
            number = attempts;
        } else if (parts[0] === "attempts") {
            number = max;
        } else if (parts[0] === "attempts-left") {
            number = max - attempts;
        } else if (parts[0] === "attempt-nth") {
            text += numberToOrdinal(attempts);
        } else if (parts[0] === "attempts-th") {
            text += numberToOrdinal(max);
        }

        if (parts.length > 1) {
            if (number > -1) {
                text += `  ${pluralize(parts[1], number)}`;
            } else {
                text += ` ${parts[1]}`;
            }
        }

        return text;
    });

    return replacedMessage;
};

const getMessageText = (
    messages,
    currentLeaveExamAttempts,
    maxLeaveExamAttempts
) => {
    const headerMessage = messages[MESSAGE_IDS.EXAM_EVENTS.LEAVE_FULL_SCREEN];
    let message = headerMessage;

    if (maxLeaveExamAttempts > 0) {
        if (currentLeaveExamAttempts >= maxLeaveExamAttempts) {
            message =
                headerMessage +" "+
                insertNumbersIntoMessage(
                    messages[MESSAGE_IDS.EXAM_EVENTS.LEAVE_EXAM_MAX],
                    currentLeaveExamAttempts,
                    maxLeaveExamAttempts
                );
        } else {
            message =
                headerMessage +" "+
                insertNumbersIntoMessage(
                    messages[MESSAGE_IDS.EXAM_EVENTS.LEAVE_EXAM_ATTEMPT],
                    currentLeaveExamAttempts,
                    maxLeaveExamAttempts
                );
        }
    }

    return message;
};

export { getMessageText };
